// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { floppyDiskThreeDots16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-floppy-disk-three-dots': IconFloppyDiskThreeDots;
    }
}

/**
 * The icon component for the 'floppyDiskThreeDots' icon
 */
export class IconFloppyDiskThreeDots extends Icon {
    public constructor() {
        super(floppyDiskThreeDots16X16);
    }
}

registerIcon('icon-floppy-disk-three-dots', IconFloppyDiskThreeDots);
export const iconFloppyDiskThreeDotsTag = 'nimble-icon-floppy-disk-three-dots';
